export default __webpack_public_path__ + "static/facts-global-392bbd850114ec7b04f32a27f8989e6a.webp";